export const LEVELS = [0, 1, 2, 3, 4, 5];

export const LEVEL_IDS = [0, 1, 4, 7, 10, 13];

export const ACTUAL_LEVEL_IDS = [
  {
    id: 0,
    label: '0',
  },
  {
    id: 1,
    label: '1',
  },
  {
    id: 4,
    label: '2',
  },
  {
    id: 7,
    label: '3',
  },
  {
    id: 10,
    label: '4',
  },
  {
    id: 13,
    label: '5',
  },
];

export const RESULT_LEVELS = [
  '0',
  '1',
  '1+',
  '2-',
  '2',
  '2+',
  '3-',
  '3',
  '3+',
  '4-',
  '4',
  '4+',
  '5-',
  '5',
];

export const RESULT_ACTUAL_LEVELS = ['0', '1', '2', '3', '4', '5'];

export const LEVEL_DEFEINITIONS = {
  0: {
    title: 'LEVEL 0 - No/Minimal Knowledge',
    description:
      'No/Minimal knowledge or awareness of the topic, no experience or exposure to relevant activities within a technical environment. No questions will be presented at this level.',
  },
  1: {
    title: 'LEVEL 1 - Elementary Knowledge',
    description:
      'Has elementary knowledge/can recall some information of the topic. Would have limited experience to apply basic skills under supervision only. Further training and experience required.',
  },
  2: {
    title: 'LEVEL 2 - Limited Knowledge',
    description:
      'Has limited knowledge/can recall some information of the skill area when used. Has appropriate experience to apply skills under supervision or alone to a basic level. Further training and experience recommended.',
  },
  3: {
    title: 'LEVEL 3 - Moderate Comprehension/Understanding',
    description:
      'Has a broad based level of knowledge and experience, can explain and demonstrate to others in situations of average complexity and can successfully apply skills independently requiring limited supervision.',
  },
  4: {
    title: 'LEVEL 4 - Considerable Knowledge/Application',
    description:
      'Has detailed knowledge and experience of this skill area and can critically evaluate and adapt as required in complex environments. Has successfully executed skill set.',
  },
  5: {
    title: 'LEVEL 5 - Extensive/Strategic Application',
    description:
      'Has in-depth knowledge of this topic. Has successfully and independently applied the skill via direct and management of complex situations. Recognised as fully conversant in this area and may be called on by others for advice or guidance as a Subject Matter Expert.',
  },
};

export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
